import React from 'react';
import Card from '@material-ui/core/Card';
import {Link} from 'react-router-dom'
const PriceItem = (props) => {
    // Declare a new state variable, which we'll call "count"
    const percentState = number =>{
        let className= "";
        if(number > 0){
            className ="green-txt";
        }else if(number < 0){
            className ="red-txt";
        }
        return className;
    }
    const {item} = props;
    return (
        <Card className="price-item">
            <Link to={`/details/${props.item.id}`}>
            <span className="price-name">
    <span className={`price-percenage  ${percentState(item.percentage)}`}>{Math.abs(item.percentage)}%</span>
                {item.name}
            </span>
            <span className="current-price">
                {item.price}
                <span className="unit">{item.unit}</span>
            </span>
            <span className="current-date">
                <span className="date">{item.date}</span>
                <span className="time">{item.time}</span>
            </span>
            </Link>

        </Card>
    );
};
export default PriceItem;